import { render, staticRenderFns } from "./user-refund.vue?vue&type=template&id=a1d5ecc8&scoped=true&"
import script from "./user-refund.vue?vue&type=script&lang=js&"
export * from "./user-refund.vue?vue&type=script&lang=js&"
import style0 from "./user-refund.vue?vue&type=style&index=0&id=a1d5ecc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d5ecc8",
  null
  
)

export default component.exports